import React, { useCallback } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import { Select } from "antd";

const MultipleSelect = ({
  label,
  name,
  placeholder = "Select options",
  options = [],
  ...rest
}) => {
  const handleChange = useCallback((value) => {
    // This will be called within Field render props context
  }, []);
  const selectStyles = {
    width: "100%",
  };

  return (
    <div className="mb-3">
      <div className="mb-1">
        <label htmlFor={name} className="font-medium">
          {label}
        </label>
      </div>
      <Field name={name}>
        {({ field, form }) => {
          const hasError = form.errors[name] && form.touched[name];
          const status = hasError ? "error" : "";

          const fieldValue = Array.isArray(field.value) ? field.value : [];

          return (
            <Select
              id={name}
              mode="multiple"
              allowClear
              placeholder={placeholder}
              value={fieldValue}
              options={options}
              onChange={(value) => form.setFieldValue(name, value)}
              style={selectStyles}
              status={status}
              {...rest}
            />
          );
        }}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
};

export default MultipleSelect;
